import { render, staticRenderFns } from "./tableFinancialStatement.vue?vue&type=template&id=69ecdc14&scoped=true"
import script from "./tableFinancialStatement.vue?vue&type=script&lang=js"
export * from "./tableFinancialStatement.vue?vue&type=script&lang=js"
import style0 from "./tableFinancialStatement.vue?vue&type=style&index=0&id=69ecdc14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ecdc14",
  null
  
)

export default component.exports